import { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { navGroups, platforms, platformItems, visibleFor } from './navigation';
import { basePath } from '@/lib/base';

export const AdminNav = ({ user, psp, onNavigate, badges = {} }) => {
  const location = useLocation();
  const base = basePath();
  const current = new URLSearchParams(location.search).get('platform') || '';
  const [openMenu, setOpenMenu] = useState(current);
  useEffect(() => { if (current) setOpenMenu(current); }, [current]);
  const group = (g) => {
    const items = g.items.filter((i) => visibleFor(i, user, psp));
    if (!items.length) return null;
    return <div className="admin-nav-group" key={g.title}>
      <div className="admin-nav-label">{g.title}</div>
      {items.map((item) => <NavLink key={item.to} to={`${base}${item.to}`} end={item.end} onClick={onNavigate} data-testid={item.testid}
        className={({ isActive }) => `admin-nav-link ${isActive ? 'is-active' : ''}`}>
        <item.icon aria-hidden="true" /><span>{item.label}</span>{badges[item.to] ? <span className="ml-auto px-1.5 py-0.5 rounded-full bg-red-600 text-white text-[10px] font-mono leading-none" data-testid={`nav-badge${item.to.replace('/', '-')}`}>{badges[item.to]}</span> : null}
      </NavLink>)}
    </div>;
  };
  return <nav className="admin-navigation" aria-label="Navigation principale" data-testid="admin-navigation">
    {navGroups.slice(0, 1).map(group)}
    {platformItems('').some((i) => i.perm && visibleFor(i, user, psp)) && <div className="admin-nav-group" data-testid="nav-boutiques-group">
      <div className="admin-nav-label">Boutiques</div>
      {platforms.map((platform) => <div key={platform.key}>
        <button type="button" onClick={() => setOpenMenu(openMenu === platform.key ? '' : platform.key)} className="admin-nav-link w-full" data-testid={`nav-platform-${platform.key}`} aria-expanded={openMenu === platform.key} aria-controls={`platform-menu-${platform.key}`}>
          <platform.icon aria-hidden="true" /><span>{platform.label}</span>
          <ChevronDown className={`ml-auto transition-transform ${openMenu === platform.key ? 'rotate-180' : ''}`} />
        </button>
        {openMenu === platform.key && <div className="admin-nav-nested" id={`platform-menu-${platform.key}`} data-testid={`platform-menu-${platform.key}`}>
          {platformItems(platform.key).filter((item) => visibleFor(item, user, psp)).map((item) => {
            const active = location.pathname === `${base}${item.to}` && current === platform.key;
            return <Link key={item.to} to={`${base}${item.to}?platform=${platform.key}`} onClick={onNavigate} data-testid={item.testid} aria-current={active ? 'page' : undefined} className={`admin-nav-link ${active ? 'is-active' : ''}`}>
              <item.icon aria-hidden="true" /><span>{item.label}</span>
            </Link>;
          })}
        </div>}
      </div>)}
    </div>}
    {navGroups.slice(1).map(group)}
  </nav>;
};